import { ArrowDownBoldIcon } from './ArrowDownBoldIcon';

/**
 * author: Austin Andrews
 * id CA8684F7-5654-4AE0-9840-9C3AD9611D19
 * name arrow-down-bold
 * version: 1.9.32
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-down-bold.svg
 * tags
 * - Arrow 
 */
export const ArrowBottomBoldIcon = ArrowDownBoldIcon;
export default ArrowBottomBoldIcon